import { computeBearing } from './directionEngine';
import type { BearingResult } from './directionTypes';
import type { RssiProcessor } from './rssiProcessor';

export type HeadingProvider = {
  getHeadingDeg(): number | null;
};

export class ProximityTracker {
  private targetId: string | null = null;

  constructor(
    private readonly rssiProcessor: RssiProcessor,
    private readonly headingProvider: HeadingProvider,
  ) {}

  startTracking(peerId: string): void {
    this.targetId = peerId;
  }

  stopTracking(): void {
    this.targetId = null;
  }

  getTargetPeerId(): string | null {
    return this.targetId;
  }

  getBearing(): BearingResult | null {
    if (this.targetId === null) {
      return null;
    }
    return computeBearing(
      this.rssiProcessor,
      { headingDeg: this.headingProvider.getHeadingDeg() },
      this.targetId,
    );
  }
}
